import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-efficiency',
    templateUrl: './efficiency.component.html',
    styleUrls: ['./efficiency.component.scss'],
    standalone: false
})
export class EfficiencyComponent {
  @Input() actualPower: number; // will be removed
  @Input() theoreticalPower: number; // will be removed
  @Input() efficiency: number;
}
